import { render, staticRenderFns } from "./LawStatisticDetails.vue?vue&type=template&id=8a276b58&scoped=true"
import script from "./LawStatisticDetails.vue?vue&type=script&lang=js"
export * from "./LawStatisticDetails.vue?vue&type=script&lang=js"
import style0 from "./LawStatisticDetails.vue?vue&type=style&index=0&id=8a276b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a276b58",
  null
  
)

export default component.exports